import { useRef, useLayoutEffect } from 'react';
import { Events } from 'react-scroll';
export const useScrollingRef = () => {
    const ref = useRef(false);
    useLayoutEffect(() => {
        Events.scrollEvent.register('begin', () => {
            ref.current = true;
        });
        Events.scrollEvent.register('end', () => {
            ref.current = false;
        });
        return () => {
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
    }, [ref]);
    return ref;
};
export default useScrollingRef;
